
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-terms",
      function () {
        return require("private-next-pages/payment-terms.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-terms"])
      });
    }
  